<template>
  <footer class="footer">

    <span>&copy; 2019-{{ new Date().getFullYear() }} <a href="https://fusebox.online" target="_blank" class="link">Fusebox.online</a></span>
    <!--    <span><a @click=showModalTos class="link lowercase">{{ $t('terms.tos') }}</a></span>-->
    <!--    <span><a @click=showModalPrivacy class="link lowercase">{{ $t('terms.privacy') }}</a></span>-->
    <span><a href="https://dolphiq.nl" target="_blank" class="link">Dolphiq BV</a></span>

  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {}
  },
  methods: {}
}
</script>
